const CANONICAL_ORIGIN = "https://motoscheduler.com";

export const ALLOWED_HOSTS = new Set([
  "motoscheduler.com",
  "robsdyno.malejkoit.com",
  "robsdyno.motoscheduler.com",
  "malejkoit.motoscheduler.com",
]);

export const getHostRedirectUrl = (hostname: string): string | null => {
  const normalizedHostname = hostname.toLowerCase();

  if (
    normalizedHostname === "localhost" ||
    ALLOWED_HOSTS.has(normalizedHostname)
  ) {
    return null;
  }

  return CANONICAL_ORIGIN;
};
